import { call, put, delay } from 'redux-saga/effects';
import processError from '../../../utils/processError';
import {
  loadAwaitDocumentIdListBegin, loadAwaitDocumentIdListFailed, loadAwaitDocumentIdListSuccessful,
} from '../actions';
import { resolveActionPromise } from '../../../utils/resolveActionPromise';
import makeRequest from '../../../utils/makeRequest';
import { rejectActionPromise } from '../../../utils/rejectActionPromise';
import { OK } from '../../../configs/serverStatusCodes';
import { BACKEND_URL, BACKEND_URL_V2, LOADING_DELAY } from '../../../configs';
import addFilterQueryWithCondition, { addFilterQuery } from '../../../utils/addFilterQueryWithCondition';

export default function* loadAwaitDocumentIdList(action) {
  try {
    const { payload = {} } = action;
    const {
      filter,
    } = payload;
    const pool = {};
    if (typeof filter === 'object' && Object.keys(filter).length) {
      yield delay(LOADING_DELAY);
      pool.filter = addFilterQuery(filter);
    }
    const url = `${BACKEND_URL_V2}/documents/ids`;
    yield put(loadAwaitDocumentIdListBegin());
    const dataResponse = yield makeRequest(url, {
      ...pool,
    }, action, 'POST', true);
    const data = yield dataResponse.json();
    if (dataResponse.status === OK) {
      yield put(loadAwaitDocumentIdListSuccessful(data));
      yield call(resolveActionPromise(action, data));
    } else {
      yield put(loadAwaitDocumentIdListFailed());
      yield call(rejectActionPromise(action, data));
    }
  } catch (e) {
    yield put(loadAwaitDocumentIdListFailed());
    yield call(rejectActionPromise(action, e));
    yield processError(e);
  } finally {
    yield call(resolveActionPromise(action));
  }
}
